'use client';
import { jsx } from 'react/jsx-runtime';
import { omitThemingProps } from '@chakra-ui/styled-system';
import { cx } from '@chakra-ui/utils';
import { ProgressStylesProvider, ProgressContextProvider } from './progress-context.mjs';
import { splitProgressProps } from './progress-props.mjs';
import { getProgressProps } from './progress-utils.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { useMultiStyleConfig } from '../system/use-style-config.mjs';
import { chakra } from '../system/factory.mjs';

const ProgressRoot = forwardRef(
  function ProgressRoot2(props, ref) {
    const ownProps = omitThemingProps(props);
    const styles = useMultiStyleConfig("Progress", props);
    const [progressProps, restProps] = splitProgressProps(ownProps);
    const computed = getProgressProps(progressProps);
    return /* @__PURE__ */ jsx(
      chakra.div,
      {
        ref,
        ...restProps,
        __css: styles.root,
        className: cx("chakra-progress", props.className),
        children: /* @__PURE__ */ jsx(ProgressStylesProvider, { value: styles, children: /* @__PURE__ */ jsx(ProgressContextProvider, { value: { computed, ...progressProps }, children: restProps.children }) })
      }
    );
  }
);
ProgressRoot.displayName = "Progress";

export { ProgressRoot };
